module.exports = __webpack_public_path__ + "media/flags/ls-0370b393.svg";